<template>
    <div>
         <b-form @submit.prevent="onSubmit()">
            <b-form-group>
                <label>
                    Title
                </label>
                
                <b-form-input
                    type="text"
                    v-model="form.title"
                    required>    
                </b-form-input>

                <label>
                    Body
                </label>

                <b-form-textarea
                    v-model="form.body"
                    required>    
                </b-form-textarea>
            </b-form-group>

            <b-button type="submit" variant="primary">
                Submit
            </b-button>
        </b-form>
    </div>
</template>

<script>

    export default {
        props: ['eventId'],

        data() {
            return {
                form: {
                    event_id: this.eventId,
                    title: "",
                    body: ""
                }
            }
        },

        methods: {
            onSubmit() {
                this.$emit('created', { ...this.form });
                this.clear();
            },

            clear() {
                this.form.title = "";
                this.form.body = "";
            }
        }
    }
</script>

<style scoped>
    .form-group {
        margin: 0;
    }

    textarea {
        margin-bottom: 10px;
    }
</style>